import {
  NOTIFICATIONS_ACKNOWLEDGE,
  NOTIFICATIONS_STATUS,
} from "constants/notifications";
import { cloneDeep } from "lodash";

export const constructStatusQueryString = (url, data) => {
  if (!data) return url;
  let qString = url;

  qString = `${qString}${url.includes("?") ? "&" : "?"}`;

  const list = [];

  Object.keys(data).forEach((key) => {
    if (data[key] !== null && data[key] !== "") {
      let value = data[key];
      if (value === "null") {
        value = null;
      }
      list.push(`${STATUS_KEY[key]}=${value}`);
    }
  });
  return qString + list.join("&");
};

const STATUS_KEY = {
  unit: "unit",
  site: "site",
  organisationId: "organisation",
  organisation: "filter__organisation__eq",
  group: "filter__group__eq",
  installer: "filter__installer_organisation__eq",
  lifecycle: "filter__state__eq",
  control_mode_status: "filter__control_mode_status__eq",
  regulatory_control: "filter__regulatory_mode__eq",
  meter: "filter__meter__eq",
  search: "filter__search__like",
  online: "filter__online__eq",
  state: "filter__state_name__eq",
  dnsp: "filter__dnsp__eq",
  limit: "limit",
  offset: "offset",
  order: "order",
  pageSize: "limit",
  page: "offset",
  eventType: "filter__event__contains",
  severity: "filter__severity__lte",
  timestampGt: "filter__timestamp__gt",
  resolved: "filter__active__not_exists",
  resolvedNeq: "filter__active__exists",
  closed: "filter__closed__exists",
  closedNeq: "filter__closed__not_exists",
  acknowledgedBy: "filter__acknowledged_by__eq",
  acknowledged: "filter__acknowledged__exists",
  reportFrom: "report_from",
  reportTo: "report_to",
  chart: "chart",
  list: "list",
  field: "filter__field__eq",
  channel: "filter__channel__eq",
  modem_rate_plan: "filter__modem_rate_plan__eq",
  modem_projection_mb: "filter__modem_projection_mb__gte",
  source: "filter__source__eq",
  price_type: "filter__price_type__eq",
  tariff_type: "filter__tariff_type__eq",
  retailer: "filter__retailer__eq",
};

export const getNotificationsFormdata = (formdata, username) => {
  let data = cloneDeep(formdata);
  if (data.resolved) {
    if (data.resolved === NOTIFICATIONS_STATUS.ALL) {
      data.resolved = null;
    } else if (data.resolved === NOTIFICATIONS_STATUS.ACTIVE) {
      data.resolvedNeq = true;
    } else if (data.resolved === NOTIFICATIONS_STATUS.OPEN) {
      data["closedNeq"] = true;
    } else if (data.resolved === NOTIFICATIONS_STATUS.CLOSED) {
      data["closed"] = true;
    }
    data.resolved = null;
  }

  if (data.acknowledged) {
    if (data.acknowledged === NOTIFICATIONS_ACKNOWLEDGE.ALL) {
      data.acknowledged = null;
    } else if (data.acknowledged === NOTIFICATIONS_ACKNOWLEDGE.UNACKNOWLEDGED) {
      data.acknowledged = "null";
    } else if (
      data.acknowledged === NOTIFICATIONS_ACKNOWLEDGE.MYNOTIFICATIONS
    ) {
      data.acknowledged = null;
      data["acknowledgedBy"] = username;
    }
  }
  return data;
};
